class AutoplotTargetValidator {
    /**
     * Constructs an instance of AutoplotTargetValidator.
     * @param {Object} model - The model object to be validated.
     * @param {Object} $injector - The injector service for dependency injection.
     */
    constructor(model, $injector) {
        this.model = model;
        this.$injector = $injector;

        this._TaskDataService = null;
        this._translate = null;
        this._fetchContext = null;
        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.LOGIC.RICHTEXT-ACTIVED-AUTOPLOT';
        this._message = null;
        this._forced_check = false;
    }

    /**
     * Lazily initializes and returns the TaskDataService.
     * @returns {Object} The TaskDataService instance.
     */
    getTaskDataService() {
        if (!this._TaskDataService) {
            this._TaskDataService = this.$injector.get('TaskDataService');
        }
        return this._TaskDataService;
    }

    /**
     * Lazily initializes and returns the $translate service.
     * @returns {Object} The $translate service instance.
     */
    getTranslateService() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Lazily initializes and returns the fetchContext.
     * @returns {Object} The fetchContext instance.
     */
    getFetchContext() {
        if (!this._fetchContext) {
            this._fetchContext = this.getTaskDataService().fetchContext();
        }
        return this._fetchContext;
    }

    /**
     * Validates the model based on its type and preferences.
     * @param {string} from - The source from which the validation is triggered.
     * @returns {Object} The validation result.
     */
    validate(from) {
        let error = false;

        if (this.model.getObjectType() === 'table') {
            const objects = this.getFetchContext().findInstancesByType('contentObject');
            for (let key in objects) {
                if (objects.hasOwnProperty(key)) {
                    const object = objects[key];
                    if (object.getObjectType() !== 'auto-plot-from-table') {
                        continue;
                    }
                    if (object.getPreferences().targetTableObject && object.getPreferences().targetTableObject === this.model.getUUID()) {
                        object.validate(from);
                        break;
                    }
                }
            }
        } else if (this.model.getObjectType() === 'auto-plot-from-table') {
            if (this.model.getPreferences() && this.model.getPreferences().targetTableObject) {
                const targetTableObject = this.getFetchContext().read(this.model.getPreferences().targetTableObject);
                if (targetTableObject && targetTableObject.getPreferences().richTextEnabled === true) {
                    error = true;
                }
            }
        }

        return {
            'onSheetBlur':      false,
            'onlyBanner':       false,
            'validator':        this.getValidatorName(),
            'modelUUID':        this.model.getUUID(),
            'error':            error,
            'status':           error ? 'DANGER' : 'SUCCESS', // WARNING | DANGER | SUCCESS
            'message':          this.getErrorMessage(),
            'message_template': false,
            'callbacks':        [
                'validationDisplayObjectHeader-' + this.model.getUUID()
            ]
        };
    }

    /**
     * Returns the error message for the validation.
     * @returns {string} The error message.
     */
    getErrorMessage() {
        const questionHeadline = this.model.getQuestionHeadline();
        this._message = this.getTranslateService().instant(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Returns the forced check status.
     * @returns {boolean} The forced check status.
     */
    isForcedCheck() {
        return this._forced_check;
    }

    /**
     * Returns the name of the validator.
     * @returns {string} The validator name.
     */
    getValidatorName() {
        return 'AutoplotTargetValidator';
    }
}

export default AutoplotTargetValidator;